import React, { useState, useEffect } from 'react';
import { API } from '@/App';
import axios from 'axios';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function TechValueStats() {
  const [data, setData] = useState(null);
  const [month, setMonth] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchStats = async (m) => {
    setLoading(true);
    try {
      const url = m ? `${API}/dashboard/tech-value-stats?month=${m}` : `${API}/dashboard/tech-value-stats`;
      const r = await axios.get(url);
      setData(r.data);
      if (!month) setMonth(r.data.month);
    } catch (e) { console.error('Tech value stats error:', e.message); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchStats(); }, []); // eslint-disable-line

  if (loading) return <div className="p-12 text-center text-zinc-400">Chargement...</div>;
  if (!data) return null;

  const totals = data.technicians.reduce((acc, t) => ({
    total: acc.total + t.total_embouts,
    under: acc.under + t.embouts_under_72h,
    over: acc.over + t.embouts_over_72h,
    sav: acc.sav + t.embouts_sav_error,
    gained: acc.gained + t.value_gained,
    lost: acc.lost + t.value_lost,
    net: acc.net + t.net_value,
  }), { total: 0, under: 0, over: 0, sav: 0, gained: 0, lost: 0, net: 0 });

  return (
    <div data-testid="tech-value-stats">
      <div className="flex items-center gap-4 mb-6">
        <div className="flex-1">
          <h2 className="text-lg font-heading font-semibold">Suivi Valeur par technicien</h2>
          <p className="text-sm text-zinc-500">Performance mensuelle embouts et valeur</p>
        </div>
        <Select value={month} onValueChange={(v) => { setMonth(v); fetchStats(v); }}>
          <SelectTrigger className="w-48 rounded-sm bg-white" data-testid="tech-value-month">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-white">
            {data.available_months?.map(m => (
              <SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="bg-white border border-zinc-200 overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="bg-zinc-50">
              <TableHead className="label-overline">Technicien</TableHead>
              <TableHead className="label-overline text-center">Total</TableHead>
              <TableHead className="label-overline text-center text-emerald-700">&lt; 3j</TableHead>
              <TableHead className="label-overline text-center text-red-700">&ge; 3j</TableHead>
              <TableHead className="label-overline text-center text-rose-700">SAV err.</TableHead>
              <TableHead className="label-overline text-center text-emerald-700">Gagne</TableHead>
              <TableHead className="label-overline text-center text-rose-700">Perdu</TableHead>
              <TableHead className="label-overline text-center font-bold">Net</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.technicians.map((t, i) => (
              <TableRow key={t.name} data-testid={`tech-row-${t.name}`}>
                <TableCell className="font-medium">{t.name}</TableCell>
                <TableCell className="text-center font-bold">{t.total_embouts}</TableCell>
                <TableCell className="text-center text-emerald-700 font-bold">{t.embouts_under_72h}</TableCell>
                <TableCell className="text-center text-red-700 font-bold">{t.embouts_over_72h}</TableCell>
                <TableCell className="text-center text-rose-700 font-bold">{t.embouts_sav_error}</TableCell>
                <TableCell className="text-center text-emerald-700 font-mono">+{t.value_gained.toFixed(0)}€</TableCell>
                <TableCell className="text-center text-rose-700 font-mono">-{t.value_lost.toFixed(0)}€</TableCell>
                <TableCell className={`text-center font-mono font-bold ${t.net_value >= 0 ? 'text-emerald-700' : 'text-rose-700'}`}>
                  {t.net_value >= 0 ? '+' : ''}{t.net_value.toFixed(0)}€
                </TableCell>
              </TableRow>
            ))}
            {/* Totals row */}
            <TableRow className="bg-zinc-900 text-white">
              <TableCell className="font-bold">TOTAL</TableCell>
              <TableCell className="text-center font-bold">{totals.total}</TableCell>
              <TableCell className="text-center font-bold">{totals.under}</TableCell>
              <TableCell className="text-center font-bold">{totals.over}</TableCell>
              <TableCell className="text-center font-bold">{totals.sav}</TableCell>
              <TableCell className="text-center font-mono font-bold">+{totals.gained.toFixed(0)}€</TableCell>
              <TableCell className="text-center font-mono font-bold">-{totals.lost.toFixed(0)}€</TableCell>
              <TableCell className="text-center font-mono font-bold">{totals.net >= 0 ? '+' : ''}{totals.net.toFixed(0)}€</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
